<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="ionicon ion-icon"
      viewBox="0 0 512 512"
    >
      <title>DropIn</title>
      <line class="st0" x1="346.42" y1="197.04" x2="263.41" y2="301.15" />
      <line class="st0" x1="179.63" y1="261.45" x2="263.41" y2="301.15" />
      <path
        class="st1"
        d="M263.24,60.23c43.86-0.27,88.13,13.57,125.54,42.45c89.03,68.73,105.48,196.62,36.75,285.64
        s-196.62,105.48-285.64,36.75S34.4,228.46,103.13,139.43c12.35-15.99,26.6-29.64,42.19-40.88"
      />
      <polyline class="st2" points="44.01,108.87 164.07,60.76 147.92,189.09" />
    </svg>
  </template>
  <style lang="css">
  .st0 {
    fill: none;
    stroke-width: 40;
    stroke-linecap: round;
    stroke-miterlimit: 10;
    stroke:currentColor;
  }
  .st1 {
    fill: none;
    stroke-width: 40;
    stroke-linecap: round;
    stroke-miterlimit: 10;
    stroke:currentColor;
  }
  .st2 {
    fill: none;
    stroke-width: 40;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
    stroke:currentColor;
  }
  </style>
